import { taskManagementRoutes } from './taskManagementRoutes';

const base = taskManagementRoutes.tasks;

export const taskRoutes = {
  base,
  create: `${base}/create`,
  taskId: (id: string) => `${base}/${id}` as const,
  notFound: `${base}/task-not-found`,
} as const;
